import React, { useState } from 'react'
import classNames from 'classnames'
import { Sector } from 'recharts'
import { VuiChartTooltip } from '@topkamera/viso-ui'

const truncateLabel = (label, maxLength = 9) => {
  if (!label || typeof label !== 'string') return label
  return label.length > maxLength ? `${label.substring(0, maxLength)}...` : label
}

export const shapeDoughnutActive = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
    </g>
  )
}

export const ShapePieBackground = (props) => {
  const { cx, cy, outerRadius } = props

  return (
    <g>
      <circle cx={cx} cy={cy} r={outerRadius} fill="#eee" stroke="none" />
    </g>
  )
}

export const AxisTick = (props) => {
  const { x, y, payload } = props
  return (
    <text x={x} y={y} dy={16} textAnchor="middle" fontSize={14}>
      {payload.value}
    </text>
  )
}

export const LegendItems = (props) => {
  const { payload, iconType = 'square', legendPosition = 'right', metrics, truncateLegendLabels = false, enableLegendTooltip = false } = props

  const [tooltipPayload, setTooltipPayload] = useState(null)
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 })

  const handleMouseEnter = (rawLabel, displayLabel, color, tooltipLabel) => {
    if (!enableLegendTooltip) return
    const label = tooltipLabel || rawLabel

    setTooltipPayload([
      [
        {
          hasDivider: false,
          label: '',
          value: label,
          color
        }
      ]
    ])
  }

  const handleMouseLeave = () => {
    if (!enableLegendTooltip) return
    setTooltipPayload(null)
  }

  const handleMouseMove = (event) => {
    if (!enableLegendTooltip) return

    setTooltipPosition({
      x: event.clientX + 8,
      y: event.clientY - 16
    })
  }

  return (
    <div
      className={classNames('viso-legend', `viso-legend--${legendPosition}`)}
    >
      {metrics && payload.map((entry, index) => {
        const findMetric = metrics.find(def => def.dataKey === (entry.dataKey || entry.value))

        if (entry.value === 'fillBg') return null

        const rawLabel = (findMetric && findMetric.name) ? findMetric.name : entry.value
        const displayLabel = truncateLegendLabels ? truncateLabel(rawLabel) : rawLabel
        const tooltipLabel = (findMetric && (findMetric.fullName || findMetric.name))
          ? (findMetric.fullName || findMetric.name)
          : entry.value
        const color = findMetric?.fill

        return (
          <div
            key={`item-${index}`}
            className='viso-legend-item'
            onMouseEnter={() => handleMouseEnter(rawLabel, displayLabel, color, tooltipLabel)}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
          >
            <div
              className={`viso-legend-item__icon viso-legend-item__icon--${iconType}`}
              style={{ backgroundColor: color }}
              // title={rawLabel}
            />
            <div 
              // className='viso-legend-item__name viso-legend-item__tooltip'
              className='viso-legend-item__name'
              element-tooltip={tooltipLabel}
              // title={tooltipLabel}
            >
              {displayLabel}
            </div>
          </div>
        )
      })}

      {enableLegendTooltip && tooltipPayload && (
        <div
          className='viso-legend__tooltip'
          style={{ top: tooltipPosition.y, left: tooltipPosition.x }}
        >
          <VuiChartTooltip payload={tooltipPayload} />
        </div>
      )}
    </div>
  )
}